import React from "react";
import { Icon, Popover } from "@amzn/awsui-components-console";

/**
 * FUSEN Execution Mode — how FUSEN WF should resolve the effective event version
 * for a FUSENWorkflow redrive. Only applies to FUSENWorkflow redrives.
 */
export const FUSEN_EXECUTION_MODE_NORMAL = "NORMAL";
export const FUSEN_EXECUTION_MODE_REDRIVE = "REDRIVE";
export const FUSEN_EXECUTION_MODE_REDRIVE_WITH_HIGHER_VERSION =
  "REDRIVE_WITH_HIGHER_VERSION";

export const FUSEN_EXECUTION_MODE_OPTIONS = [
  { value: FUSEN_EXECUTION_MODE_NORMAL },
  { value: FUSEN_EXECUTION_MODE_REDRIVE },
  { value: FUSEN_EXECUTION_MODE_REDRIVE_WITH_HIGHER_VERSION },
];

/**
 * The event version override is only meaningful in NORMAL mode; in the two redrive
 * modes FUSEN WF derives the version from what it finds in record.
 */
export function isEventVersionOverrideDisabled(
  fusenExecutionMode: string,
): boolean {
  return (
    fusenExecutionMode === FUSEN_EXECUTION_MODE_REDRIVE ||
    fusenExecutionMode === FUSEN_EXECUTION_MODE_REDRIVE_WITH_HIGHER_VERSION
  );
}

/** Help icon with a popover explaining each FUSEN Execution Mode. */
export const FusenExecutionModeHelp = () => (
  <Popover
    renderWithPortal
    size="medium"
    position="top"
    triggerType="text"
    dismissButton={false}
    header="FUSEN Execution Mode"
    content={
      <ul style={{ paddingLeft: "1rem", margin: 0 }}>
        <li>
          <strong>NORMAL</strong>: use the specified event version override
        </li>
        <li>
          <strong>REDRIVE</strong>: use the same version as the largest FUSEN
          version found in record, or 0 if none is found (recommended for
          transient issue)
        </li>
        <li>
          <strong>REDRIVE_WITH_HIGHER_VERSION</strong>: use the largest FUSEN
          version found in record + 1, or 0 if none is found (recommended for
          transaction correction)
        </li>
      </ul>
    }
  >
    <Icon name="status-info" variant="link" />
  </Popover>
);
